import { Box, Typography } from '@mui/material'
import React from 'react'

interface InputProps {
  title: string
  subTitles?: string[]
}

export const BaseStepLayout: React.FC<InputProps> = ({ title, subTitles = [], children }) => {
  return (
    <Box sx={{ textAlign: 'left', minWidth: '500px' }}>
      <Box mb={2}>
        <Typography variant='h4'>{title}</Typography>
      </Box>
      {subTitles.map((subTitle, index) => {
        return (
          <Box key={index}>
            <Typography whiteSpace='pre-wrap' variant='subtitle1'>
              {subTitle}
            </Typography>
          </Box>
        )
      })}
      <Box mt={2}>{children}</Box>
    </Box>
  )
}
